/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Card, CardHeader, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { KeyboardActions } from '../../shared/enums/KeyboardActions';

const useStyles = makeStyles(theme => ({
  pdfIconInactive: {
    opacity: 0.25,
  },
  card: {
    backgroundColor: theme.palette.white,
    borderColor: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.cardActive,
    },
    marginBottom: theme.spacing(2),
  },
  cardActive: {
    backgroundColor: theme.palette.cardActive,
    borderColor: theme.palette.primary.active,
    pointerEvents: 'none',
  },
  cardTitle: {
    wordBreak: 'break-word',
  },
  default: {
    maxWidth: 345,
    borderRadius: '.2rem',
    borderWidth: '2px',
    borderStyle: 'solid',
    boxShadow: '0px 1px 3px rgba(63, 63, 68, 0.15)',
    boxSizing: 'border-box',
  },
}));

export default function Minicard({ title, subtitle, icon, onClick, isActive }) {
  const classes = useStyles();
  const handleKeyDown = (e) => {
    if (e.keyCode === KeyboardActions.ENTER) {
      onClick(e);
    }
  };

  const component = (
    <Card
      className={clsx(classes.default, classes.card, isActive && classes.cardActive)}
      onClick={onClick}
      aria-controls="filePreview"
      tabIndex="0"
      onKeyDown={handleKeyDown}
    >
      <CardHeader
        avatar={{
          ...icon,
          props: {
            ...icon.props,
            className: !isActive ? classes.pdfIconInactive : null,
          },
        }}
        title={title}
        subheader={subtitle}
        className={classes.cardTitle}
      />
    </Card>
  );
  return useMemo(() => component, [
    title,
    subtitle,
    icon,
    onClick,
    isActive,
  ]);
}
